import ability from '@u/ability'

export default {
  setAuth(state, payload) {
    state.auth = payload.auth
    if (typeof payload.expiration !== 'undefined') {
      state.sessionExpiration = payload.expiration
      try {
        if (payload.expiration) {
          localStorage.setItem('sessionExpiration', payload.expiration)
        } else {
          localStorage.removeItem('sessionExpiration')
        }
      } catch {}
    }
    if (payload.remember) {
      state.remember = payload.remember
    }
    state.errors = payload.errors
  },
  setErrors(state, errors) {
    state.errors = errors
  },

  setPermissions(state) {
    const permissions = state.auth.permissions

    const arrayAbilities = []
    permissions.map((perm) =>
      arrayAbilities.push({ action: perm, subject: 'all' })
    )
    ability.update([])
    ability.update(arrayAbilities)
  }
}
